// Site Content provider — fetches the editable marketing copy once and shares
// it across all section components. Falls back to baked-in defaults if the API
// call fails (so the landing page never breaks on a network blip).
import { createContext, useContext, useEffect, useState } from "react";
import { getSiteContent } from "./api";

const FALLBACK = {
  lab_date_primary_label: "August 27, 2026",
  lab_date_primary_time: "6:30–9:00 PM EST",
  lab_date_secondary_label: "",
  lab_date_secondary_status: "",
  lab_price_label: "$249",
  lab_duration_label: "2.5 hours",
  intro_offer_line:
    "At $249 with Klarna & Afterpay, this is the cheapest way to actually build with AI live — with real-time help — instead of hunting for tutorials on your own.",
  klarna_afterpay_line: "Klarna & Afterpay available at checkout — split into 4 payments.",
  problem_statement_html:
    "<p>Voice notes. Canva boards. Whiteboards. Conversations that never turn into shipped work — because you're waiting on a developer, a designer, a tech person, or a bigger budget.</p><p>You know you need a better website. <strong>You don't know where to start.</strong></p><p>You want a customer dashboard, an intake system, a workflow — but the quotes are wild.</p><p>You've been told you'd need to learn to code. You don't have time for that.</p><p class='lead'>Every month you wait, someone else is getting the leads that should be yours — and you're still stuck.</p>",
  problem_headline: "Your idea is sitting in a notebook. Again.",
  // AI Build Lab: Student Innovation and Entrepreneurship Camp
  sc_meta_title: "AI Build Lab | Student Innovation and Entrepreneurship Camp",
  sc_meta_description:
    "The AI Build Lab is a six-week, in-person after-school innovation and entrepreneurship camp where middle and high school students use AI to solve real-world problems and build an app or website.",
  sc_program_name_full: "AI Build Lab: Student Innovation and Entrepreneurship Camp",
  sc_program_name_short: "AI Build Lab",
  sc_parent_tuition_label: "",
  sc_full_cohort_price_label: "",
  sc_per_seat_price_label: "",
  sc_cohorts_open: "no",
  sc_available_cohorts_html: "",
  sc_stripe_parent_link: "",
  sc_founder_name: "Donja Williams",
  sc_founder_title: "Founder and CEO, Freedom In Me, LLC",
  sc_founder_photo_url: "",
  sc_founder_bio_html: "",
  sc_workforce_bridge_html: "",
  sc_org_description_html: "",
  sc_closing_statement: "Freedom In Me helps employers prepare for the future of work — while helping students prepare to become its future workforce.",
  sc_program_delivery_note: "",
  sc_participation_eyebrow: "How the program comes to students",
  sc_participation_headline_html: "Flexible ways to bring the <em>Lab</em> to students.",
  sc_participation_intro:
    "The AI Build Lab can be offered as an approved after-school program where parents register and pay for their students individually. Schools and community partners may also choose to sponsor a complete cohort, subsidize registration, or fund student scholarships.",
  sc_participation_note_html:
    "<p><strong>School approval</strong> creates the school-specific cohort. <strong>Parent registration</strong> secures each student's seat. School or sponsor funding may replace or reduce a parent payment — but never replaces the parent's registration and consent process.</p>",
  ffr_stripe_replay: "",
  ffr_stripe_toolkit_funding: "",
  ffr_stripe_toolkit_evidence: "",
  ffr_stripe_toolkit_program: "",
  ffr_stripe_toolkit_board: "",
  ffr_stripe_toolkit_grant: "",
  ffr_stripe_toolkit_fundraising: "",
  ffr_stripe_toolkit_operations: "",
  ffr_stripe_bundle_choose3: "",
  ffr_stripe_bundle_funding: "",
  ffr_stripe_bundle_ultimate: "",
  ffr_stripe_advisory: "",
  ffr_stripe_advisory_plus: "",
  ffr_stripe_ai_build_lab: "",
  ffr_stripe_ai_agent: "",
  ffr_download_toolkit_funding: "",
  ffr_download_toolkit_evidence: "",
  ffr_download_toolkit_program: "",
  ffr_download_toolkit_board: "",
  ffr_download_toolkit_grant: "",
  ffr_download_toolkit_fundraising: "",
  ffr_download_toolkit_operations: "",
  ffr_download_bundle_choose3: "",
  ffr_download_bundle_funding: "",
  ffr_download_bundle_ultimate: "",
  ffr_download_replay: "",
};

const Ctx = createContext(FALLBACK);

export function SiteContentProvider({ children }) {
  const [data, setData] = useState(FALLBACK);
  useEffect(() => {
    getSiteContent().then((d) => setData({ ...FALLBACK, ...d })).catch(() => {});
  }, []);
  return <Ctx.Provider value={data}>{children}</Ctx.Provider>;
}

export function useSiteContent() {
  return useContext(Ctx);
}
